
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magic",
      function () {
        return require("private-next-pages/magic.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magic"])
      });
    }
  